/* eslint-disable */
import Header from "components/Common/Header/Header";
import CompanySuccessStoriesBody from "components/CompaniesComponents/CompanyDetails/CompanySuccessStories/SuccessStoriesBody/CompanySuccessStoriesBody";
import React, { useEffect } from "react";

const CompanySuccessStories = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Company Success Stories";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="successstories" />

      {/* ------ body section --------- */}
      <CompanySuccessStoriesBody />
    </main>
  );
};

export default CompanySuccessStories;
